import React, { useContext, useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "./Common/Components/AuthContext";
import { useToast } from "./Common/Components/ToastProvider";
import LoadingSpinner from "./Common/Components/LoadingSpinner";

const ProtectedRoute = ({ role }) => {
  const {
    isUserAuthenticated,
    isAdminAuthenticated,
    isSuperAdminAuthenticated,
    authLoading
  } = useContext(AuthContext);
  const location = useLocation();
  const { showToast } = useToast();
  const hasShownToast = useRef(false);
  
  // Determine if the user is authenticated based on their role
  const isAuthenticated =
    (role === "user" && isUserAuthenticated) ||
    (role === "admin" && isAdminAuthenticated) ||
    (role === "superadmin" && isSuperAdminAuthenticated);

  // Show toast only once when authentication fails
  useEffect(() => {
    if (!authLoading && !isAuthenticated && !hasShownToast.current) {
      showToast("You are not logged in", "error");
      hasShownToast.current = true;
    }
  }, [isAuthenticated, showToast, authLoading]);

  // Show loading state while checking auth
  if (authLoading) {
    return <LoadingSpinner />;
  }

  // Redirect based on role if not authenticated
  if (!isAuthenticated) {
    let redirectPath = "/";
    if (role === "user") redirectPath = "/login";
    if (role === "admin") redirectPath = "/admin/login";
    if (role === "superadmin") redirectPath = "/superadmin/login";
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;